import { clearFix, rem, rgba } from 'polished';
import styled from 'styled-components';

import { breakpoints, misc } from 'helpers/styles/constants';
import { container } from 'helpers/styles/mixins';

export const headerHeightSticky = misc.headerHeight + 40;

export const Section = styled.section`
  @media ${breakpoints.mdUp} {
    float: right;
    margin-left: auto;
    width: calc(100% - ${rem(405)});
  }
`;

export const NavItem = styled.div`
  &:not(:last-child) {
    margin-bottom: ${rem(35)};
  }

  a {
    display: flex;
    cursor: pointer;
    transition: 0.3s ease color;

    &:hover,
    &.active {
      color: ${({ theme }) => theme.colors.accent};
    }
  }

  span {
    display: inline-block;
    min-width: ${rem(30)};
    vertical-align: top;
  }
`;

export const Nav = styled.nav`
  position: sticky;
  top: ${rem(headerHeightSticky)};
  display: none;
  float: left;
  width: ${rem(345)};
  padding: ${rem(40)} ${rem(30)};
  background: linear-gradient(
    180deg,
    ${({ theme }) => theme.colors.catshillWhite} 0%,
    ${({ theme }) => theme.colors.aquaHaze} 100%
  );
  box-shadow: 0 ${rem(20)} ${rem(20)} ${rem(-10)} ${({ theme }) => rgba(theme.colors.calypso, 0.2)};

  @media ${breakpoints.mdUp} {
    display: block;
  }
`;

export const Wrapper = styled.div`
  ${container()};
  ${clearFix()};
  position: relative;
  margin-bottom: ${rem(100)};
`;
